<template lang="pug">
v-menu(offset-y rounded="lg" max-width="640" :close-on-content-click="false" left max-height="444" nudge-bottom="4")
  template(v-slot:activator="{ on }")
    v-btn.round-md(v-on="on" color="white" depressed)
      v-icon.mr-3(size=20 color="neutral500") $yzi-calendar-filter
      .text-sm.text-none(v-if="selectedOption") {{ selectedOption.name }}: {{ dateText }}
  .white
    v-row(no-gutters)
      v-col(cols="5")
        .d-flex
          v-radio-group.ma-0.flex-grow-1(v-model="radioGroup" mandatory)
            template(v-for="option in options")
              v-radio.px-4.py-2.my-0(:value="option.id")
                template(v-slot:label)
                  .text-sm.font-normal.primary--text.mt-1 {{ option.name }}
              v-divider.basic300

          v-divider.basic300(vertical)
      v-col(cols="7")
        .pa-4
          .text-sm.font-semibold {{ dateText }}
        v-divider.basic300
        yc-date-picker.range-date-picker(:parentDate.sync="selectedDates" range :readonly="readonly")
</template>

<script>
import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'

export default {
  name: 'RangeDropdown',
  data: () => ({
    readonly: true,
    radioGroup: null,
    selectedDates: null,
    options: [
      { id: 'yesterday', name: 'Yesterday' },
      { id: 'lastSeven', name: 'Last 7 days' },
      { id: 'lastThirty', name: 'Last 30 days' },
      { id: 'lastNinety', name: 'Last 90 days' },
      { id: 'thisWeek', name: 'This week' },
      { id: 'thisMonth', name: 'This month' },
      { id: 'thisYear', name: 'This year' },
      { id: 'lastWeek', name: 'Last week' },
      { id: 'lastMonth', name: 'Last month' },
      { id: 'custom', name: 'Custom' },
    ],
  }),
  computed: {
    ...mapGetters({
      dates: 'insight/getDates',
      currentDateRange: 'insight/getCurrentDateRange'
    }),
    selectedOption () {
      let selected = this.options.find(i => i.id == this.radioGroup)
      if (selected) {
        return selected
      }
      return this.options[0]
    },
    dateText () {
      if (this.selectedDates && this.selectedDates.length > 0) {
        const start = this.selectedDates[0]
        let end = this.selectedDates[1]
        if (!end) {
          end = start
        }
        const dateFormat = 'd MMM yyyy'
        const startDate = DateTime.fromFormat(start, 'yyyy-MM-dd').toFormat(dateFormat)
        const endDate = DateTime.fromFormat(end, 'yyyy-MM-dd').toFormat(dateFormat)
        return `${startDate} - ${endDate}`
      }
      return '-'
    }
  },
  watch: {
    radioGroup (val) {
      this.setDateRange(val)
    },
    selectedDates (val, oldVal) {
      if (oldVal !== val) {
        this.setNewDates(val)
      }
    }
  },
  mounted () {
    this.selectedDates = this.dates
    this.radioGroup = this.currentDateRange?.id || 'yesterday'
    // this.setNewDates(this.selectedDates)
  },
  methods: {
    setDateRange(val) {
      const now = DateTime.local()
      const dateFormat = 'yyyy-MM-dd'
      this.readonly = true
      switch (val) {
        case 'yesterday': {
          const start = now.minus({ days: 1 })
          this.selectedDates = [start.toFormat(dateFormat), start.toFormat(dateFormat)]
          break
        }
        case 'lastSeven': {
          const start = now.minus({ days: 6 })
          this.selectedDates = [start.toFormat(dateFormat), now.toFormat(dateFormat)]
          break
        }
        case 'lastThirty': {
          const start = now.minus({ days: 30 })
          this.selectedDates = [start.toFormat(dateFormat), now.toFormat(dateFormat)]
          break
        }
        case 'lastNinety': {
          const start = now.minus({ days: 90 })
          this.selectedDates = [start.toFormat(dateFormat), now.toFormat(dateFormat)]
          break
        }
        case 'thisWeek': {
          const start = now.startOf('week')
          const end = now.endOf('week')
          this.selectedDates = [start.toFormat(dateFormat), end.toFormat(dateFormat)]
          break
        }
        case 'thisMonth': {
          const start = now.startOf('month')
          const end = now.endOf('month')
          this.selectedDates = [start.toFormat(dateFormat), end.toFormat(dateFormat)]
          break
        }
        case 'thisYear': {
          const start = now.startOf('year')
          const end = now.endOf('year')
          this.selectedDates = [start.toFormat(dateFormat), end.toFormat(dateFormat)]
          break
        }
        case 'lastWeek': {
          const lastWeek = now.minus({ weeks: 1 })
          const lastWeekStart = lastWeek.startOf('week')
          const lastWeekEnd = lastWeek.endOf('week')
          this.selectedDates = [lastWeekStart.toFormat(dateFormat),lastWeekEnd.toFormat(dateFormat)]
          break
        }
        case 'lastMonth': {
          const lastMonth = now.minus({ months: 1 })
          const lastMonthStart = lastMonth.startOf('month')
          const lastMonthEnd = lastMonth.endOf('month')
          this.selectedDates = [lastMonthStart.toFormat(dateFormat),lastMonthEnd.toFormat(dateFormat)]
          break
        }
        case 'custom': {
          this.readonly = false
          break
        }
        default:
          break
      }
    },
    setNewDates (val) {
      let newValue = val
      if (!val[1]) {
        newValue = [val[0], val[0]]
      }
      newValue = newValue.sort()
      this.$store.commit('insight/setBeginDate', newValue[0])
      this.$store.commit('insight/setUntilDate', newValue[1])
      this.$store.commit('insight/setDates', val)
      this.$store.commit('insight/setCurrentDateRange', this.selectedOption)
    }
  }
}
</script>

<style lang="scss">
.range-date-picker {

  .v-date-picker-table .v-btn.v-date-picker-table__current {
    color: #333333 !important;
  }

  .v-date-picker-table .v-btn.v-btn--active {
    background-color: #EEEEEE !important;
    color: #333333 !important;
  }

  .v-date-picker-table .v-btn.v-btn--active.v-date-picker--first-in-range, .v-btn.v-btn--active.v-date-picker--last-in-range {
    background-color: #333333 !important;
    .v-btn__content {
      color: #ffffff;
    }
  }

  .v-date-picker-table .v-btn {
    font-weight: 500;
    font-size: 16px !important;
  }

  .v-date-picker-table__current {
    border: 2px solid black !important;
  }
}
</style>